<template>
  <teleport to="body">
    <div
      class="modal fade subscriptionWarning-modal"
      tabindex="-1"
      aria-labelledby="subscriptionWarningModalLabel"
      aria-hidden="true"
      ref="subscriptionWarningModal"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeButton"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label"
                >У вас нет доступа к ресурсу, просьба зарегистрироваться, а если
                хотите больше ресурсов, приобретите нужную подписку.</label
              >
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary w-100"
              @click="handleAction"
            >
              {{ isLoggedIn ? "Приобрести подписку" : "Зарегистрироваться" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "BuyASubscriptionWarningModal",
  setup() {
    const store = useStore();
    const router = useRouter();
    const subscriptionWarningModal = ref(null);
    let modalInstance = null;
    const isLoggedIn = computed(() => store.state.auth.status.loggedIn);

    const openModal = () => {
      if (modalInstance) {
        modalInstance.show();
      }
    };

    const handleAction = () => {
      if (isLoggedIn.value) {
        router.push({ name: "Tariffs" });
      } else {
        router.push("/login");
      }

      if (modalInstance) modalInstance.hide();
    };

    onMounted(() => {
      if (subscriptionWarningModal.value) {
        modalInstance = Modal.getOrCreateInstance(
          subscriptionWarningModal.value
        );
      } else {
        console.error("Модальное окно не найдено");
      }
    });

    return {
      openModal,
      subscriptionWarningModal,
      isLoggedIn,
      handleAction,
    };
  },
});
</script>

<style scoped lang="scss">
.form-label {
  display: flex;
  justify-content: center;
}

.modal-footer {
  margin-top: 20px;
}
</style>
